import { CoordinatorService } from './coordinator.service';
import { ScriptBase } from './script-base';
import { ScriptHitset } from './script-hitset';
import { SearchArchiveItem } from './search-archive-item';

export class ScriptArchivedSearch extends ScriptBase {
    #coords: CoordinatorService;
    #search: SearchArchiveItem;

    constructor(coords: CoordinatorService, sai: SearchArchiveItem) {
        super(coords);
        this.#coords = coords;
        this.#search = sai;
    }

    get target() {
        return this.#search;
    }

    get title() {
        return this.#search.title;
    }

    set title(t: string) {
        this.#search.title = t;
    }

    get id() {
        return this.#search.id;
    }

    hitset() {
        return this.run();
        // return new ScriptHitset(this.#coords);
    }

    run() {
        return this.#search.run();
    }

    log(prefix = 'Archived search') {
        console.log(prefix, this.#search.title);
        return this;
    }

    display = this.log;
}
